import { render, staticRenderFns } from "./AppPodcast.vue?vue&type=template&id=53e422ee&scoped=true&"
import script from "./AppPodcast.vue?vue&type=script&lang=js&"
export * from "./AppPodcast.vue?vue&type=script&lang=js&"
import style0 from "./AppPodcast.vue?vue&type=style&index=0&id=53e422ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e422ee",
  null
  
)

export default component.exports